import type { ReactNode } from "react";

interface DialogProps {
	children: ReactNode;
}
export const Dialog = (props: DialogProps) => {
	return (
		<div>
			<div className={"portal-shadow"}></div>
			<div className={"portal"}>{props.children}</div>
		</div>
	);
};
